import * as Types from 'src/actions/physical-person/update/Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'src/reducers/RootReducer';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import { AxiosResponse } from 'axios';
import PhysicalPerson from 'src/entities/PhysicalPerson';
import ValidatorService from 'src/services/validation/Validation.service';
import { Validation } from 'src/services/validation/Validator';

export interface UpdatePhysicalPersonAttempt extends Action {
  type: Types.UPDATE_PHYSICAL_PERSON_ATTEMPT;
}

export interface UpdatePhysicalPersonSuccess extends Action {
  type: Types.UPDATE_PHYSICAL_PERSON_SUCCESS;
}

export interface UpdatePhysicalPersonFailure extends Action {
  type: Types.UPDATE_PHYSICAL_PERSON_FAILURE;
  payload: {};
}

export type UpdatePhysicalPersonAction =
  UpdatePhysicalPersonAttempt |
  UpdatePhysicalPersonSuccess |
  UpdatePhysicalPersonFailure;

export interface UpdatePhysicalPersonThunk extends ThunkAction<Promise<UpdatePhysicalPersonAction>, RootState, null> {
}

export const updatePhysicalPersonAttempt: ActionCreator<UpdatePhysicalPersonAttempt> = () => (
  {type: Types.UPDATE_PHYSICAL_PERSON_ATTEMPT}
);

export const updatePhysicalPersonSuccess: ActionCreator<UpdatePhysicalPersonSuccess> = () => (
  {
    type: Types.UPDATE_PHYSICAL_PERSON_SUCCESS,
  }
);

export const updatePhysicalPersonFailure: ActionCreator<UpdatePhysicalPersonFailure> = (error: {}) => (
  {
    type: Types.UPDATE_PHYSICAL_PERSON_FAILURE,
    payload: error
  }
);

export const updatePhysicalPerson: ActionCreator<UpdatePhysicalPersonThunk> = (
  physicalPerson: PhysicalPerson
): UpdatePhysicalPersonThunk => {

  return (dispatch: Dispatch<RootState>): Promise<UpdatePhysicalPersonAction> => {

    dispatch(updatePhysicalPersonAttempt());

    let restrictions: Validation[] = [
      {value: physicalPerson.name, message: 'name'},
      {value: physicalPerson.surname, message: 'surname'},
    ];

    const validations = ValidatorService.validate(restrictions);

    return validations.then(() => {
      return ApiClient.physicalPerson.update(physicalPerson.id, physicalPerson)
        .then((response: AxiosResponse): UpdatePhysicalPersonSuccess => {
          return dispatch(updatePhysicalPersonSuccess());
        }).catch((e: { response: { data: { errors: {} } } }): UpdatePhysicalPersonFailure => {
          const errorMessages = ValidatorService
            .translateValidations(e && e.response && e.response.data && e.response.data.errors);

          return dispatch(updatePhysicalPersonFailure(errorMessages));
        });
    }).catch((errors): UpdatePhysicalPersonFailure => {
      return dispatch(updatePhysicalPersonFailure(errors));
    });
  };
};



// WEBPACK FOOTER //
// ./src/actions/physical-person/update/UpdatePhysicalPerson.actions.tsx